import {
    Accordion,
    ACCORDION_BASE_CLASSNAME,
    createAccordion,
    IAccordionBusinessLogic,
} from '@vfde-brix/ws10/accordion';
import { createComponent } from '@vfde-brix/ws10/core';
import { toggleAccordionItem } from 'Container/App/slice';
import { useDispatch } from '../store';

/**
 * Accordion component
 */
const mountAccordion = (container: Element, properties = {}): Accordion => createAccordion(container, properties);

/**
 * Mount all other editorial accordions
 */
export const mountEditorialAccordions = (
    excludes: string[] = [],
    dom: Document | HTMLElement = document,
) => {
    const dispatch = useDispatch();

    const elements = dom.getElementsByClassName(ACCORDION_BASE_CLASSNAME);

    for (let i = 0, x = elements.length; i < x; i += 1) {
        const containerElement = elements[i].parentElement;

        if (containerElement && excludes.indexOf(containerElement.id) === -1) {
            createComponent<IAccordionBusinessLogic, Accordion>(mountAccordion, containerElement, {
                onToggle: itemProperties => dispatch(toggleAccordionItem({
                    stdId: itemProperties.stdId,
                    stdHeadline: itemProperties.stdHeadline,
                    optOpen: itemProperties.optOpen,
                })),
            });
        }
    }
};

export default mountAccordion;
